<template>
  <div
    class="flex items-center gap-1.5 px-2 py-0.5 hover:bg-gray-700 cursor-pointer group"
    @click="$emit('open')"
  >
    <!-- Status character -->
    <span :class="statusColor" class="text-[10px] font-mono w-3.5 shrink-0">{{ statusChar }}</span>

    <!-- File name -->
    <span class="flex-1 truncate text-[11px] text-gray-300" :title="file.path">
      {{ fileName }}
    </span>

    <!-- Stage / unstage action button -->
    <button
      class="opacity-0 group-hover:opacity-100 text-gray-500 hover:text-white text-[10px] px-0.5 shrink-0"
      :title="mode === 'staged' ? 'Unstage' : 'Stage'"
      @click.stop="$emit('action')"
    >{{ mode === 'staged' ? '−' : '+' }}</button>

    <!-- Diff button -->
    <button
      class="opacity-0 group-hover:opacity-100 text-gray-500 hover:text-white text-[10px] px-0.5 shrink-0"
      title="Show diff"
      @click.stop="$emit('diff')"
    >⊡</button>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { GitFile } from '@/services/gitService'

const props = defineProps<{
  file: GitFile
  mode: 'staged' | 'unstaged'
}>()

defineEmits<{
  (e: 'open'): void
  (e: 'action'): void
  (e: 'diff'): void
}>()

const statusChar = computed(() =>
  props.mode === 'staged' ? props.file.index : props.file.working_dir
)

const statusColor = computed(() => {
  const s = statusChar.value
  if (s === 'M') return 'text-yellow-400'
  if (s === 'A') return 'text-green-400'
  if (s === 'D') return 'text-red-400'
  if (s === '?') return 'text-gray-400'
  return 'text-gray-400'
})

const fileName = computed(() => props.file.path.split('/').pop() ?? props.file.path)
</script>
